<script>
    import { createEventDispatcher } from 'svelte';
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let totals = {
        critical : 0,
        high     : 0,
        medium   : 0,
        low      : 0,
    };

    export let totals_by_status = {
        critical: {
            open          : 0,
            accepted      : 0,
            fixed         : 0,
            false_positive: 0

        },
        high: {
            open          : 0,
            accepted      : 0,
            fixed         : 0,
            false_positive: 0

        },
        medium: {
            open          : 0,
            accepted      : 0,
            fixed         : 0,
            false_positive: 0

        },
        low: {
            open          : 0,
            accepted      : 0,
            fixed         : 0,
            false_positive: 0

        }
    }

    let filter = null;
    let severity_shown;

    const dispatchFilterEvent = (severity) => {
        filter = severity;
        translateSeverity(severity);
        dispatch("filter", severity);
    }

    const translateSeverity = (severity) => {
        if(severity == 'low') severity_shown = 'baja'
        else if (severity == 'medium') severity_shown = 'media'
        else if (severity == 'high') severity_shown = 'alta'
        else if (severity == 'critical')severity_shown = 'crítica'
        else { severity_shown = null}
        return severity_shown;
    }

    const translateStatus = (status)=>{
        let name = {
            open: 'Ab',
            accepted: 'Ac',
            fixed: 'S',
            false_positive: 'FP'
        }
        return name[status];
    }

    const clearFilter = () => {
        filter = null;
        severity_shown = '';
        dispatch("clearFilter");
    }

</script>

<style>
    /* box */
    .cvss-box {
        text-align  : center;
        font-size   : 1.8em;
        color       : white;
        height      : 4em;
    }

    /*.card {
        cursor: pointer;
    }*/

    .card.no-hover .card-header {
        margin-left: -7.5px;
        margin-right: -7.5px;
    }

    /*.card.no-hover:hover{
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
    }*/

    /*.card.filter,
    .card:hover {
        box-shadow: inset 0px 0px 5px 0px #ccc;
    }*/

    .small-box.critical {
        background: #9046844d linear-gradient(180deg, #904684b3, #904684e6) repeat-x !important;
    }

    .small-box.high {
        background: #a021284d linear-gradient(180deg, #a02128b3, #a02128e6) repeat-x !important;
    }

    .small-box.medium {
        background: #d4652f4d linear-gradient(180deg, #d4652fb3, #d4652fe6) repeat-x !important;

    }

    .small-box.low {
        background: #f7ba0b80 linear-gradient(180deg, #f7ba0bb3, #f7ba0be6) repeat-x !important;
    }

    .small-box .info-box-text{
        font-size: 1.1em;
        color: white;
    }

    .totals-by-status {
        font-size: 0.8rem;
    }

    .muted {
        color:rgba(0, 0, 0, 0.5);
    }


</style>

<div class="row">
    {#each Object.entries(totals) as [name,total]}
        <div class="col-3">
            <div class="card card-{name}" class:filter={filter == name} title={"Ver prioridad " + translateSeverity(name) + (name != "critical" ? " y superior" : "")} on:click={()=>dispatchFilterEvent(name)}>
            <div class="card-header card-header-slim text-dashboard-box" style="text-align: center; font-size: 1.6em">{$format(`vulnerability.severity.${name}`).charAt(0).toUpperCase() + $format(`vulnerability.severity.${name}`).slice(1)}</div>
            <div class="card-body text-dashboard-box pb-3 pt-3" style="text-align: center">
                <div class={"t-severity-totals-" + name + "-value"}>{total}</div>
                    <div class="totals-by-status">
                        {#if totals_by_status}
                            {#each Object.entries(totals_by_status[name]) as [status, count], i }
                                {#if status != 'ignored'}
                                    <span class:muted={status == 'fixed' || status == 'false_positive'} class={"t-severity-totals-" + name + "-" + (status == 'false_positive' ? "false-positive" : status)}>{translateStatus(status)}: {count}</span>
                                    {#if (i + 1) < Object.keys(totals_by_status).length } |&nbsp; {/if}
                                {/if}
                            {/each}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    {/each}
</div>